import { NBSP } from 'shared/constants/symbols';
import { IFourthUtpBlock } from 'shared/types/utp';

export const UTP: IFourthUtpBlock[] = [
  {
    title: { value: `Регистрация сделки за${NBSP}1 день, без визитов в МФЦ и банк` },
    image: 'calendar',
  },
  {
    title: { value: `Поддержка${NBSP}ипотечных и безипотечных${NBSP}сделок` },
    image: 'buildings',
  },
  {
    title: { value: `Высокий уровень безопасности${NBSP}за счёт верификации и электронной подписи` },
    image: 'shield',
  },
  {
    title: { value: `Сопровождение клиента${NBSP}и онлайн-отслеживание статуса сделки` },
    image: 'monitor',
  },
];
